module.exports = __webpack_public_path__ + "img/hill.92ed066e.jpg";